<article class="planCard" [class.planCard--featured]="isFeatured()">
  @if (badgeText()) {
    <div class="planCard__badge">
      {{ badgeText() }}
    </div>
  }

  <div class="planCard__name">{{ planName() }}</div>

  <div class="planCard__priceRow">
    <span class="planCard__priceAmount">{{ priceLabel().amount }}</span>
    <span class="planCard__pricePeriod">{{ priceLabel().period }}</span>
  </div>

  <div class="planCard__features">
    @if (tokensDisplayLabel()) {
      <div class="planCard__featureLine">
        <span class="planCard__featureIcon" aria-hidden="true">✓</span>
        <span class="planCard__featureText">{{ tokensDisplayLabel() }}</span>
      </div>
    }
    @if (featureText()) {
      <div class="planCard__featureLine">
        <span class="planCard__featureIcon" aria-hidden="true">✓</span>
        <span class="planCard__featureText">{{ featureText() }}</span>
      </div>
    }
  </div>

  <button class="planCard__cta" type="button" [disabled]="disabled()" (click)="onSelect()">
    {{ plan().cta_text ?? 'Buy Tokens' }}
    <ui-icon name="arrow-right" [size]="16"></ui-icon>
  </button>
</article>
